import { TableCell, styled } from '@mui/material';
export const ClickableTableCell = styled(TableCell)(() => ({
    '&:hover': {
        textDecoration: 'underline',
    },
}));
